'use strict';

require('./CallsService');
var defaults = require('../../defaults/Defaults');
require('./DisplaySourceStateService');
require('./KayleeService');
var log = require('../../log/Log').channel('ControlController');
var moment = require('moment');
require('./RoomService');
var sutl = require('../../sutl/Sutl');
var objectToArray = require('./ObjectToArray');

angular.module('inara').controller('ControlController', ControlController);

ControlController.$inject = [
    '$rootScope',
    '$scope',
    '$state',
    '$timeout',
    'ionicMaterialInk',
    'Idle',
    'KayleeService',
    'RoomService',
    'CallsService',
    'ViewStateService',
    'ThemeService',
    '$ionicHistory',
    '$ionicPopup',
    '$ionicViewSwitcher',
    'gettextCatalog',
    '$interval',
    '$q',
    'ImageDownloadService',
    'DisplaySourceStateService',
    'RoomPasswordService',
];

function ControlController(
    $rootScope,
    $scope,
    $state,
    $timeout,
    ionicMaterialInk,
    Idle,
    KayleeService,
    RoomService,
    CallsService,
    ViewStateService,
    ThemeService,
    $ionicHistory,
    $ionicPopup,
    $ionicViewSwitcher,
    gettextCatalog,
    $interval,
    $q,
    ImageDownloadService,
    DisplaySourceStateService,
    RoomPasswordService
) {
    var vm = this;
    vm.room = null;
    var directory = null;
    var site = null;
    var unwatchCallCount = null;
    var configuredCaps = null;
    var idleEnabled;
    var idleTimeout;
    var contentBadgeCount = 0;
    var directoryCaps;
    var previousDirectoryModifiedTimestamp = null;
    var previousConfiguredDisplays = null;
    var sideBarMinimized = true;
    var channelFavoriteImages = {};
    var channelFavoritesCleanupPromise = null;

    ImageDownloadService.setImageCache('channelFavorites', channelFavoriteImages);
    updateDirectoryCaps();

    function getLogoUrl() {
        return ThemeService.getImageUrl('logo');
    }

    vm.getActiveCallCount = function () {
        return CallsService.getActiveCallCount();
    };
    vm.isSideBarMinimized = isSideBarMinimized;

    /// Main navigation button label for camera controls page
    vm.getCameraButtonLabel = function () {
        return gettextCatalog.getString('Camera');
    };
    vm.showCameraControls = function () {
        var cameraSwitchers = sutl.getNode(configuredCaps, 'cameraSwitchers');
        return (
            cameraSwitchers !== null &&
            objectToArray(cameraSwitchers).filter(function (cameraSwitcher) {
                return !cameraSwitcher.isHidden;
            }).length > 0
        );
    };
    /// Main navigation button label for calendar page
    vm.getCalendarButtonLabel = function () {
        return gettextCatalog.getString('Calendar');
    };
    vm.showCalendarControls = function () {
        if (!vm.room) return false;
        return sutl.getNode(vm.room, 'caps.hasCalendar', false);
    };
    vm.showDialpadControls = function () {
        return (
            CallsService.hasConfiguredCallCapsClass('audio') ||
            CallsService.hasConfiguredCallCapsClass('video')
        );
    };
    /// Main navigation button label for recent calls page
    vm.getRecentsButtonLabel = function () {
        return gettextCatalog.getString('Recent');
    };
    vm.showRecentsControls = function () {
        return vm.showDialpadControls() && sutl.getNode(site, 'settings.recentCallsEnabled', true);
    };
    /// Main navigation button label for directory page
    vm.getDirectoryButtonLabel = function () {
        if (sutl.getNode(vm.room, 'configuredCaps.callSupportsInvitation.zoom', false)) {
            if (directoryCaps.audio > 0 || directoryCaps.video > 0) {
                return gettextCatalog.getString('Meet Now & Directory');
            } else {
                return gettextCatalog.getString('Meet Now');
            }
        }
        return gettextCatalog.getString('Directory');
    };
    vm.showDirectoryControls = function () {
        if (!vm.room) return false;
        return (
            sutl.getNode(vm.room, 'configuredCaps.hasDirectory', false) ||
            sutl.getNode(vm.room, 'configuredCaps.callSupportsInvitation.zoom', false)
        );
    };
    /// Main navigation button label for display & sharing page
    vm.getDisplayButtonLabel = function () {
        return gettextCatalog.getString('Display & Sharing');
    };
    vm.showDisplayControls = function () {
        var displays = sutl.getNode(configuredCaps, 'displays');
        return (
            displays !== null &&
            objectToArray(displays).filter(function (display) {
                return !display.isHidden;
            }).length > 0
        );
    };
    vm.getDialPadButtonLabel = function () {
        if (dialPadSupportsJoin() && CallsService.hasConfiguredCallCapsClass('audio')) {
            /// Main navigation button label for dial pad (with audio and Zoom conferencing)
            return gettextCatalog.getString('Join & Dial');
        } else if (dialPadSupportsJoin()) {
            /// Main navigation button label for dial pad (with Zoom conferencing only)
            return gettextCatalog.getString('Join');
        }
        /// Main navigation button label for dial pad (without Zoom conferencing)
        return gettextCatalog.getString('Dial Pad');
    };
    vm.contentActiveBadge = function () {
        return contentBadgeCount > 0 ? contentBadgeCount : '';
    };
    vm.getLightingButtonIcon = function () {
        var hasLighting = hasLightingControls() || hasLightingPresets();
        var hasShades = hasShadeControls() || hasShadePresets();
        if (hasShades && !hasLighting) {
            return 'ion-aveo-shades-half-open';
        }
        return 'ion-aveo-lightbulb-on-outline';
    };
    vm.getLightingButtonLabel = function () {
        var hasLighting = hasLightingControls() || hasLightingPresets();
        var hasShades = hasShadeControls() || hasShadePresets();
        if (hasLighting && hasShades) {
            /// Main navigation button label for lighting & shades page
            return gettextCatalog.getString('Lighting & Shades');
        } else if (hasShades) {
            /// Main navigation button label for shades page
            return gettextCatalog.getString('Shades');
        } else {
            /// Main navigation button label for lighting page
            return gettextCatalog.getString('Lighting');
        }
    };
    vm.showLightingControls = function () {
        return (
            hasLightingControls() || hasLightingPresets() || hasShadeControls() || hasShadePresets()
        );
    };
    /// Main navigation button label for audio source page
    vm.getAudioSourceButtonLabel = function () {
        return gettextCatalog.getString('Audio Source');
    };
    vm.showAudioSourceControls = function () {
        var audioInputSources = sutl.getNode(configuredCaps, 'audioInputSources');
        return audioInputSources !== null && Object.keys(audioInputSources).length > 0;
    };
    vm.getPowerOffButtonIcon = function () {
        return sutl.getNode(site, 'settings.roomPowerOffEnabled', false)
            ? 'ion-aveo-power'
            : 'ion-android-lock';
    };
    vm.getPowerOffButtonLabel = function () {
        return sutl.getNode(site, 'settings.roomPowerOffEnabled', false)
            ? /// Power off room (button label)
              gettextCatalog.getString('Power Off')
            : /// Lock room (button label)
              gettextCatalog.getString('Lock Room');
    };
    vm.showPowerOffControls = function () {
        return (
            sutl.getNode(site, 'settings.roomPowerOffEnabled', false) ||
            (sutl.getNode(vm.room, 'settings.userPassword') !== null &&
                RoomPasswordService.isSupported())
        );
    };
    vm.hasLogo = function () {
        var logoUrl = getLogoUrl();
        return logoUrl !== null && logoUrl !== '';
    };
    vm.getLogoStyle = function () {
        var logoUrl = getLogoUrl();
        var style = {};
        if (logoUrl !== null && logoUrl !== '') {
            style['background-image'] = "url('" + logoUrl + "')";
        }
        return style;
    };
    vm.showSystemInfo = function () {
        $timeout(function () {
            $state.go('info.system');
        }, 100);
    };
    vm.onPowerOff = function () {
        var hasRoomPassword =
            sutl.getNode(vm.room, 'settings.userPassword') !== null &&
            RoomPasswordService.isSupported();
        var hasPowerOff = sutl.getNode(site, 'settings.roomPowerOffEnabled', false);
        closePowerOffConfirmPopup()
            .then(function () {
                $scope.powerOffConfirmPopup = $ionicPopup.show({
                    template: getConfirmMsg(hasRoomPassword, hasPowerOff),
                    cssClass:
                        hasRoomPassword && hasPowerOff
                            ? 'power-off-confirm-with-lock'
                            : 'power-off-confirm',
                    scope: $scope,
                    buttons: getConfirmButtons(hasRoomPassword, hasPowerOff),
                });
                return $scope.powerOffConfirmPopup;
            })
            .then(function (response) {
                if (response === 'lock') {
                    RoomPasswordService.lock();
                } else if (response === 'poweroff' && vm.room) {
                    vm.room.$requestRoomOff();
                }
            })
            .catch(function (err) {
                log.debug(err);
            });

        function getConfirmButtons(hasRoomPassword, hasPowerOff) {
            var buttons = [
                {
                    text: gettextCatalog.getString('Cancel'),
                    type: 'button-default',
                    onTap: function (e) {
                        return 'cancel';
                    },
                },
            ];
            if (hasRoomPassword) {
                buttons.push({
                    /// Lock room (confirm button label)
                    text: gettextCatalog.getString('Lock'),
                    type: hasPowerOff ? 'button-default' : 'button-card-highlight',
                    onTap: function (e) {
                        return 'lock';
                    },
                });
            }
            if (hasPowerOff) {
                buttons.push({
                    /// Power off room (button label)
                    text: gettextCatalog.getString('Power Off'),
                    type: 'button-card-highlight',
                    onTap: function (e) {
                        return 'poweroff';
                    },
                });
            }
            return buttons;
        }

        function getConfirmMsg(hasRoomPassword, hasPowerOff) {
            if (hasRoomPassword && hasPowerOff) {
                /// Confirmation dialog text for room power off or room password functions
                return gettextCatalog.getString(
                    'You can choose to lock the room or power off and lock the room.'
                );
            } else if (hasRoomPassword) {
                /// Confirmation dialog text for room password function
                return gettextCatalog.getString('Are you sure you want to lock the room?');
            } else if (hasPowerOff) {
                /// Confirmation dialog text for room power off function
                return gettextCatalog.getString('Are you sure you want to power off the room?');
            }
            return '';
        }
    };
    vm.getContactIcon = function (contact) {
        switch (contact.type) {
            case 'voip':
            case 'pstn':
                return 'ion-android-call';
            case 'video':
                return 'ion-aveo-video-conference';
            default:
                return '';
        }
    };
    vm.selectTab = function (uiSref) {
        if ($state.current.name === 'control.calls') {
            $ionicViewSwitcher.nextDirection('forward');
        } else {
            $ionicViewSwitcher.nextDirection('back');
        }
        $state.go(uiSref);
    };
    vm.getReturnToCallsLabel = function () {
        /// Back to call button text, pluralized for case with more than one call
        return gettextCatalog.getPlural(
            CallsService.getActiveCallCount(),
            'Back to call',
            'Back to calls'
        );
    };
    vm.getReturnToCallsCallTimer = function () {
        var call;
        var calls = CallsService.getActiveCalls();
        for (var i = 0; i < calls.length; i++) {
            if (!angular.isDefined(call) || calls[i].start < call.start) {
                call = calls[i];
            }
        }
        return angular.isDefined(call) ? call.$callTimer : undefined;
    };
    vm.getReturnToCallsCallClass = function () {
        var callClass = 'audio';
        var calls = CallsService.getActiveCalls();
        for (var i = 0; i < calls.length; i++) {
            if (KayleeService.getCallClass(calls[i].callType) === 'video') {
                return 'video';
            }
        }
        return callClass;
    };
    vm.returnToCalls = function () {
        $ionicViewSwitcher.nextDirection('back');
        $state.go(ViewStateService.getInCallState(), { call: null });
    };

    log.info('initializing');

    ionicMaterialInk.displayEffect({ duration: defaults.inara.inkDuration });
    RoomService.onOnlineChanged(onRoomServiceOnlineChanged);
    RoomService.onStateChanged(onRoomServiceStateChanged);
    ViewStateService.onInCallStateChanged(onInCallStateChanged);
    ViewStateService.onNoCallStateChanged(onNoCallStateChanged);
    ViewStateService.setControlStateInitialized(true);

    setIdleEnabled(defaults.inara.idleEnabled);
    setIdleTimeout(defaults.inara.idleTimeout);
    updateReturnToCallsButtonVisible();

    $scope.$on('IdleTimeout', onIdleTimeout);

    $scope.$on('ChildRequestedSideBarMinimize', onChildRequestedSideBarMinimize);

    $scope.$on('RequestRoomPowerOffConfirm', onRequestRoomPowerOffConfirm);

    $scope.$on('SideBarMinimized', onSideBarMinimized);

    $scope.$on('$destroy', onScopeDestroy);

    $scope.$on('$stateChangeSuccess', onStateChange);

    function closePowerOffConfirmPopup() {
        if ($scope.powerOffConfirmPopup) {
            $scope.powerOffConfirmPopup.close('cancel');
            return $scope.powerOffConfirmPopup;
        }
        return $q.resolve();
    }

    function dialPadSupportsJoin() {
        return (
            CallsService.hasConfiguredCallCapsType('zoom') ||
            CallsService.hasConfiguredCallCapsType('teams') ||
            CallsService.hasConfiguredCallCapsType('googleMeet')
        );
    }

    function hasLightingControls() {
        var lightingControls = sutl.getNode(configuredCaps, 'lightingControls');
        return lightingControls !== null && Object.keys(lightingControls).length > 0;
    }

    function hasLightingPresets() {
        var lightingPresets = sutl.getNode(configuredCaps, 'lightingPresets');
        return lightingPresets !== null && Object.keys(lightingPresets).length > 0;
    }

    function hasShadeControls() {
        var shadeControls = sutl.getNode(configuredCaps, 'shadeControls');
        var hasShadeControls = false;
        if (shadeControls !== null) {
            for (var key in shadeControls) {
                if (!shadeControls.hasOwnProperty(key)) continue;
                if (
                    (shadeControls[key].showPositionControls && shadeControls[key].position) ||
                    (shadeControls[key].showTiltControls && shadeControls[key].tilt)
                ) {
                    hasShadeControls = true;
                    break;
                }
            }
        }
        return hasShadeControls;
    }

    function hasShadePresets() {
        var shadePresets = sutl.getNode(configuredCaps, 'shadePresets');
        return shadePresets !== null && Object.keys(shadePresets).length > 0;
    }

    function isSideBarMinimized() {
        return sideBarMinimized;
    }

    // Handle transition to the call list state if a new call is ringing/connects
    function onCallCountChange(newCallCount, oldCallCount) {
        if (newCallCount > oldCallCount) {
            // Delay the state change to allow $digest to run once for the call
            // count update, so the state change will be accounted for on the
            // next $digest - fixes issue where side bar state is incorrect
            // when initially transitioning to calls list.
            $timeout(function () {
                if ($state.includes('control')) {
                    $state.go(ViewStateService.getInCallState(), { call: null });
                }
            }, 1);
        }

        // timeout here avoids prematurely showing the return to calls button on incoming call
        $timeout(updateReturnToCallsButtonVisible, 250);
    }

    function onChildRequestedSideBarMinimize(event, minimize) {
        // reflect notification to child scopes
        $scope.$broadcast('RequestSideBarMinimize', minimize);
    }

    function onDirectoryChanged() {
        updateDirectoryCaps();
    }

    function onIdleTimeout() {
        processNewCallState();

        if (idleEnabled) {
            // Delay Idle reset so any event handlers firing as a result of an
            // idle timeout can read Idle.idling() as true, if needed.
            $timeout(Idle.watch, 1);
        }
    }

    function onInCallStateChanged(inCallState) {
        processNewCallState();
    }

    function onNoCallStateChanged(noCallState) {
        // If idle disabled or user is currently idle,
        // change idle state immediately
        if (!idleEnabled || Idle.idling()) processNewCallState();
    }

    function onRequestRoomPowerOffConfirm() {
        if (
            !$state.current.name.startsWith('control.') &&
            !$state.current.name.startsWith('info.')
        ) {
            return;
        }

        // If confirmation is already in progress, cancel it and show the new one
        closePowerOffConfirmPopup().then(function () {
            $rootScope.$broadcast('SleepService', 'wake');
            $scope.powerOffCancelDuration = defaults.inara.powerOffCancelTimeout;
            $scope.getPowerOffConfirmMsg = function () {
                /// Confirmation dialog text for automatic room power off,
                /// includes powerOffDuration which is a string such as
                /// 'in 60 seconds'. (1/2)
                return gettextCatalog.getString(
                    'The equipment in this room ' +
                        'will automatically power off {{powerOffDuration}}.',
                    { powerOffDuration: formatDuration() }
                );

                function formatDuration() {
                    if ($scope.powerOffCancelDuration === 0) return '';
                    var defaultSecondsMaxThreshold = moment.relativeTimeThreshold('s');
                    var defaultSecondsMinThreshold = moment.relativeTimeThreshold('ss');
                    var defaultRounding = moment.relativeTimeRounding();
                    moment.relativeTimeThreshold('s', 61);
                    moment.relativeTimeThreshold('ss', 0);
                    moment.relativeTimeRounding(Math.ceil);
                    var duration = moment(Date.now() + $scope.powerOffCancelDuration).fromNow();
                    moment.relativeTimeThreshold('s', defaultSecondsMaxThreshold);
                    moment.relativeTimeThreshold('ss', defaultSecondsMinThreshold);
                    moment.relativeTimeRounding(defaultRounding);
                    return duration;
                }
            };
            $scope.getPowerOffCancelMsg = function () {
                /// Confirmation dialog text for automatic room power off (2/2)
                return gettextCatalog.getString(
                    'If you are still using the ' + 'room, you can cancel this action.'
                );
            };
            $scope.powerOffConfirmPopup = $ionicPopup.show({
                template:
                    '<p>{{getPowerOffConfirmMsg()}}</p>' + '<p>{{getPowerOffCancelMsg()}}</p>',
                cssClass: 'power-off-confirm',
                scope: $scope,
                buttons: [
                    {
                        text: gettextCatalog.getString('Cancel'),
                        type: 'button-card-highlight',
                        onTap: function (e) {
                            return 'cancel';
                        },
                    },
                ],
            });
            $scope.powerOffConfirmPopup
                .then(function (res) {
                    if ($scope.powerOffCancelInterval) {
                        $interval.cancel($scope.powerOffCancelInterval);
                        $scope.powerOffCancelInterval = null;
                    }
                    if (res === 'cancel') {
                        log.debug('Automatic room power off canceled');
                    }
                })
                .catch(function (err) {
                    if ($scope.powerOffCancelInterval) {
                        $interval.cancel($scope.powerOffCancelInterval);
                        $scope.powerOffCancelInterval = null;
                    }
                    log.error(err);
                });

            var intervalDurationMs = 1000;
            $scope.powerOffCancelInterval = $interval(function () {
                $scope.powerOffCancelDuration -= intervalDurationMs;
                if ($scope.powerOffCancelDuration <= 0 && $scope.powerOffCancelInterval) {
                    $scope.powerOffConfirmPopup.close();
                    vm.room.$requestRoomOff();
                }
            }, intervalDurationMs);
        });
    }

    function onRoomChanged() {
        if (vm.room === null || !RoomService.online()) return;

        configuredCaps = vm.room.configuredCaps;

        if (
            previousConfiguredDisplays === null ||
            !sutl.objEquals(previousConfiguredDisplays, configuredCaps.displays)
        ) {
            previousConfiguredDisplays = sutl.deepCopy(configuredCaps.displays);

            var channelFavoritesWithImages = [];
            var favoriteId;
            for (var displayId in vm.room.configuredCaps.displays) {
                if (!vm.room.configuredCaps.displays.hasOwnProperty(displayId)) continue;
                var display = vm.room.configuredCaps.displays[displayId];
                for (var sourceId in display.sources) {
                    if (!display.sources.hasOwnProperty(sourceId)) continue;
                    var source = display.sources[sourceId];
                    var channelFavorites = sutl.getNode(source, 'channelFavorites');
                    if (channelFavorites !== null) {
                        // cache any new channelFavorites images
                        for (favoriteId in channelFavorites) {
                            if (!channelFavorites.hasOwnProperty(favoriteId)) continue;
                            if (channelFavorites[favoriteId].image) {
                                channelFavoritesWithImages.push(favoriteId);
                                var added = !channelFavoriteImages.hasOwnProperty(favoriteId);
                                var updated =
                                    channelFavoriteImages.hasOwnProperty(favoriteId) &&
                                    channelFavoriteImages[favoriteId].storagePath !==
                                        sutl.getNode(channelFavorites, [
                                            favoriteId,
                                            'image',
                                            'path',
                                        ]);
                                if (added || updated) {
                                    var msg = added ? 'added' : updated ? 'updated' : '';
                                    log.debug(
                                        'channelFavoriteImages ' + msg + ' [' + favoriteId + ']'
                                    );
                                    updateChannelFavoriteImage(
                                        channelFavorites,
                                        source.equipmentId,
                                        favoriteId
                                    );
                                }
                            }
                        }
                    }
                }
            }
            if (channelFavoritesCleanupPromise === null) {
                channelFavoritesCleanupPromise = ImageDownloadService.deleteImagesWithExclusions(
                    'channelFavorites',
                    channelFavoritesWithImages
                ).finally(function () {
                    channelFavoritesCleanupPromise = null;
                });
            }
        }

        contentBadgeCount = DisplaySourceStateService.getActiveSourceStatesCount();

        if (
            ($state.current.name === defaults.inara.dialPadView && !vm.showDialpadControls()) ||
            ($state.current.name === defaults.inara.recentsView && !vm.showRecentsControls()) ||
            ($state.current.name === defaults.inara.cameraView && !vm.showCameraControls()) ||
            ($state.current.name === defaults.inara.displayView && !vm.showDisplayControls()) ||
            ($state.current.name === defaults.inara.calendarView && !vm.showCalendarControls()) ||
            ($state.current.name === defaults.inara.audioSourceView &&
                !vm.showAudioSourceControls()) ||
            ($state.current.name === defaults.inara.directoryView && !vm.showDirectoryControls()) ||
            ($state.current.name === defaults.inara.lightingView && !vm.showLightingControls())
        ) {
            processNewCallState();
        }

        if (
            previousDirectoryModifiedTimestamp === null ||
            previousDirectoryModifiedTimestamp !== sutl.getNode(directory, ['modified'])
        ) {
            previousDirectoryModifiedTimestamp = sutl.getNode(directory, ['modified']);
            updateDirectoryCaps();
        }

        function updateChannelFavoriteImage(channelFavorites, eqId, favoriteId) {
            var storagePath = sutl.getNode(channelFavorites, [favoriteId, 'image', 'path']);
            var key = storagePath ? storagePath.substr(0, storagePath.lastIndexOf('/image')) : null;
            key = key ? key.substr(key.lastIndexOf('/') + 1) : null;
            channelFavoriteImages[favoriteId] = {
                storagePath: storagePath,
                url: null,
                key: key,
            };
            return KayleeService.getEquipment(eqId)
                .$loaded()
                .then(function (eq) {
                    if (!channelFavoriteImages[favoriteId]) {
                        log.warning(
                            'channelFavoriteImages[' +
                                favoriteId +
                                '] removed before loading equipment'
                        );
                        return;
                    }
                    channelFavoriteImages[
                        favoriteId
                    ].storageRef = eq.$getChannelFavoriteImageStorage(favoriteId);
                    if (!channelFavoriteImages[favoriteId].storageRef) {
                        log.debug('no image for channel favorite ' + favoriteId);
                        return;
                    }
                    return ImageDownloadService.downloadImage(
                        'channelFavorites',
                        channelFavoriteImages[favoriteId].storageRef,
                        favoriteId
                    );
                });
        }
    }

    function onRoomServiceOnlineChanged(online) {
        if (online) {
            vm.room = RoomService.getRoom();
            vm.room.$onChange(onRoomChanged);
            directory = vm.room.$getDirectory();
            directory.$onChange(onDirectoryChanged);
            updateDirectoryCaps();
            site = KayleeService.getSite(vm.room.siteId);
            site.$onChange(onSiteChanged);
            unwatchCallCount = $scope.$watch(function () {
                return vm.getActiveCallCount();
            }, onCallCountChange);
        } else {
            setIdleEnabled(false);
            Idle.unwatch();

            if (vm.room !== null) {
                vm.room.$offChange(onRoomChanged);
                vm.room = null;
            }

            if (directory !== null) {
                directory.$offChange(onDirectoryChanged);
                directory = null;
            }
            configuredCaps = null;
            updateDirectoryCaps();

            if (site !== null) {
                site.$offChange(onSiteChanged);
                site = null;
            }

            if (unwatchCallCount !== null) {
                unwatchCallCount();
                unwatchCallCount = null;
            }
        }
    }

    function onRoomServiceStateChanged(state) {
        if (vm.room === null && RoomService.online()) {
            onRoomServiceOnlineChanged(true);
        } else if (vm.room !== null && !RoomService.online()) {
            onRoomServiceOnlineChanged(false);
        }
    }

    function onScopeDestroy() {
        closePowerOffConfirmPopup();
        ViewStateService.setControlStateInitialized(false);
        ViewStateService.offInCallStateChanged(onInCallStateChanged);
        ViewStateService.offNoCallStateChanged(onNoCallStateChanged);
        if (unwatchCallCount !== null) {
            unwatchCallCount();
            unwatchCallCount = null;
        }

        RoomService.offStateChanged(onRoomServiceStateChanged);
        RoomService.offOnlineChanged(onRoomServiceOnlineChanged);

        if (idleEnabled) {
            Idle.unwatch();
        }

        if (vm.room !== null) {
            vm.room.$offChange(onRoomChanged);
            vm.room = null;
        }

        if (site !== null) {
            site.$offChange(onSiteChanged);
            site = null;
        }
    }

    function onSideBarMinimized(event, minimized) {
        // received from the sidebar controller
        sideBarMinimized = minimized;
    }

    function onSiteChanged() {
        updateIdleTimeout();
        if ($state.current.name === defaults.inara.recentsView && !vm.showRecentsControls()) {
            processNewCallState();
        }
    }

    function onStateChange(event, toState, toParams, fromState, fromParams) {
        // Make every view start at the root of the history stack, so
        // views exit left and enter right every time
        if ($state.includes('control.')) {
            $ionicHistory.nextViewOptions({ historyRoot: true });
        }

        if (!toState.name.startsWith('control.')) {
            closePowerOffConfirmPopup();
        }

        if (!fromState.name.startsWith('control.') && toState.name.startsWith('control.')) {
            if (site !== null) {
                updateIdleTimeout(true);
            } else {
                setIdleEnabled(defaults.inara.idleEnabled);
                setIdleTimeout(defaults.inara.idleTimeout);
                if (idleEnabled) {
                    Idle.watch();
                }
            }
        }

        // Some drivers may update settings that change the default idle
        // screen before control state is entered, so process the call state.
        // Force volume slider to visually update when transitioning from start
        // to control - this supports a case where we have used the system
        // info page to enable fullscreen mode.
        if (fromState.name === 'start' && toState.name.startsWith('control.')) {
            processNewCallState();
            $scope.$broadcast('rzSliderForceRender');
        }

        if (
            angular.isDefined(toParams.calendarEventId) &&
            $state.current.name !== 'control.calendar'
        ) {
            $scope.$broadcast('RequestSideBarMinimize', false);
        }

        updateReturnToCallsButtonVisible();
    }

    function processNewCallState() {
        if (!RoomService.online()) return;
        if ($state.includes('control') || $state.is('roomPassword')) {
            if (vm.getActiveCallCount() === 0) {
                if (ViewStateService.getNoCallState() === defaults.inara.remoteControlView) {
                    $ionicViewSwitcher.nextDirection('forward');
                }
                $state.go(ViewStateService.getNoCallState());
            } else if (
                vm.getActiveCallCount() > 0 &&
                !$state.is(ViewStateService.getInCallState(), { call: null })
            ) {
                $state.go(ViewStateService.getInCallState(), { call: null });
            }
        }
    }

    function setIdleEnabled(value) {
        idleEnabled = value;
        log.debug('setIdleEnabled: ' + value);
    }

    function setIdleTimeout(value) {
        // Set the default here in case DeviceService isn't running
        var timeout = parseFloat(value) * 60;
        var limit = 2;

        if (timeout < limit) {
            log.error('setIdleTimeout: ' + timeout + ' limited to ' + limit);
            timeout = limit;
        }

        idleTimeout = timeout;
        log.debug('setIdleTimeout: ' + idleTimeout);
        Idle.setIdle(1);
        Idle.setTimeout(timeout - 1); // subtract idle time to correct total
    }

    function updateDirectoryCaps() {
        var tempDirectoryCaps = {
            audio: 0,
            video: 0,
            zoom: 0,
        };

        if (directory !== null) {
            for (var key in directory.entries) {
                if (!directory.entries.hasOwnProperty(key)) continue;
                for (var subkey in directory.entries[key].contacts) {
                    if (!directory.entries[key].contacts.hasOwnProperty(subkey)) continue;
                    tempDirectoryCaps[directory.entries[key].contacts[subkey].type] =
                        tempDirectoryCaps[directory.entries[key].contacts[subkey].type] + 1;
                }
            }
        }

        directoryCaps = tempDirectoryCaps;
    }

    function updateIdleTimeout(forceUpdate) {
        if (forceUpdate || idleEnabled !== site.settings.idleEnabled) {
            setIdleEnabled(site.settings.idleEnabled);
            if (idleEnabled) {
                Idle.watch();
            } else {
                Idle.unwatch();
            }
        }

        if (forceUpdate || idleTimeout !== parseFloat(site.settings.idleTimeout) * 60) {
            setIdleTimeout(site.settings.idleTimeout);
        }
    }

    function updateReturnToCallsButtonVisible() {
        vm.returnToCallsButtonVisible =
            !$state.includes(ViewStateService.getInCallState()) &&
            ((vm.getActiveCallCount() > 0 && !$state.includes('control.call-dialpad')) ||
                vm.getActiveCallCount() > 1);
    }
}

module.exports = ControlController;
